import { queryKeys } from '@query/keys'
import { usePaginatedQuery } from '@query/usePaginatedQuery'
import { useQuery } from '@tanstack/react-query'

import { useCampaignRebateSearch } from '@pages/Traders-Room/Campaign-Results/Rebate/hooks/useCampaignRebateSearch'

import { useSessionLanguage } from '@context/SessionSettingsContext'

import { initialPageData, useApiClient } from '@utils/ApiClient'
import { ClientApiClient } from '@utils/clientApi'

export const useCampaignRebateFetch = (accountId?: string, campaignId?: string) => {
  const locale = useSessionLanguage()
  const apiClient = useApiClient(ClientApiClient)

  const queryResult = useQuery({
    queryKey: queryKeys.campaign.rebateDetail(accountId, campaignId, locale),
    queryFn: () => apiClient.getTradingAccountRebateCampaignById(accountId!, campaignId!, locale),
    enabled: !!accountId && !!campaignId,
  })

  return { query: { data: queryResult.data, isLoading: queryResult.isLoading } }
}

export const useCampaignRebateResultsFetch = (
  accountId: string | undefined,
  campaignId: string | undefined,
  search: ReturnType<typeof useCampaignRebateSearch>
) => {
  const locale = useSessionLanguage()
  const apiClient = useApiClient(ClientApiClient)

  const searchKey = {
    ...search.search,
    ...search.pageQuery,
    locale,
  }

  const query = usePaginatedQuery({
    queryKey: queryKeys.campaign.rebateResults(accountId, campaignId, searchKey),
    queryFn: (pageQuery) => {
      if (accountId && campaignId) {
        return apiClient.getRebateCampaignResults(accountId, campaignId, {
          ...pageQuery,
          ...search.pageQuery,
          search: search.search,
          caller: 'ca',
          languageId: locale,
        })
      }
      return Promise.resolve(initialPageData)
    },
    enabled: !!accountId && !!campaignId,
  })

  return { query }
}
